<template>
  <div id="index">
    <el-container>
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main>
            <nav-bar></nav-bar>

            <div class="ReportDiv">
              <el-date-picker
                style="margin-bottom: 12px; float: right; width: 130px"
                v-model="monthData"
                type="month"
                align="right"
                unlink-panels
                value-format="yyyy-MM"
                :picker-options="pickerBeginDateBefore"
                :default-value="timeDefaultShow"
                :clearable="false"
                @blur="changeMonth"
              >
              </el-date-picker>
              <!-- <el-button-group style="margin-bottom:12px;float:right">
                <el-button type="primary" >{{ $t("desc.monthly") }}</el-button>
                <el-button type=" " >{{ $t("desc.quarterly") }}</el-button>
                <el-button type=" " >{{ $t("desc.annual") }}</el-button>
              </el-button-group> -->
              <div class="clear"></div>
              <el-row :gutter="24">
                <el-col :md="12" :sm="12" :xs="24">
                  <div class="block">
                    <h4>{{ $t("title.totalNumber") }}({{
                        $t("title.asOf") + this.monthData
                      }})</h4>
                    <span>{{ StatisticsData.currentCount }}</span>
                  </div>
                </el-col>
                <el-col :md="12" :sm="12" :xs="24">
                  <div class="block">
                    <h4>{{ $t("desc.UtilizationRate") }}</h4>
                    <span>{{ DefaultUtilizationRate }}</span>
                  </div>
                </el-col>
                <!-- <el-col :md="12" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 300px">
                    <h4>{{ $t("title.modelRatio") }}</h4>
                    <div
                      class="echarts"
                      id="Kchart1a"
                      style="
                        height: 330px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col> -->
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 300px">
                    <h4>{{ $t("title.ModelUtilizationRate") }}</h4>
                    <div
                      class="echarts"
                      id="Kchart1b"
                      style="
                        height: 330px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col>
                <!-- <el-col :md="12" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 300px">
                    <h4>{{ $t("title.industryRatio") }}</h4>
                    <div
                      class="echarts"
                      id="Kchart2a"
                      style="
                        height: 330px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col> -->
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 300px">
                    <h4>{{ $t("title.IndustryUtilizationRateTop102") }}</h4>
                    <div
                      class="echarts"
                      id="Kchart2b"
                      style="
                        height: 330px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col>
                <!-- <el-col :md="12" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 300px">
                    <h4>{{ $t("title.regionRatio") }}</h4>
                    <div
                      class="echarts"
                      id="Kchart3a"
                      style="
                        height: 330px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col> -->
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 300px">
                    <h4>{{ $t("title.RegionUtilizationRate") }}</h4>
                    <div
                      class="echarts"
                      id="Kchart3b"
                      style="
                        height: 330px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col>
                <!-- <el-col :md="12" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 300px">
                    <h4>{{ $t("title.customCenterRatio") }}</h4>
                    <div
                      class="echarts"
                      id="Kchart4a"
                      style="
                        height: 330px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col> -->
                <el-col :md="12" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 300px">
                    <h4>{{ $t("title.CustomCenterUtilizationRate") }}</h4>
                    <div
                      class="echarts"
                      id="Kchart4b"
                      style="
                        height: 330px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col>

                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                  <div class="block" style="position: relative; height: 370px">
                    <h4>{{$t("title.IndustryUtilizationRateTop10")}}</h4>
                    <div
                      class="echarts"
                      id="KchartLine"
                      style="
                        height: 400px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                      "
                    ></div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  getUtilizationRate,
  getStatisticsData,
  getUtilizationRate_new,
  GetRateSumByMonthRange,
  GetIndustryRateSum,
  getIndustryUtilizationRate,
} from "../../api/api";
export default {
  name: "index",

  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  data() {
    return {
      pickerBeginDateBefore: {
        disabledDate(time) {
          const date1 = new Date("2022-01-01");
          const date2 = new Date(new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2) + '-' + ('0' + (new Date().getDate())).substr(-2));
          const diff = (date2 - date1) + 60 * 60 * 24 * 1000;
          const diff2 = -new Date().getDate() * 60 * 60 * 24 * 1000;
          return (time.getTime() < Date.now() - diff) || (Date.now() < time.getTime()-diff2);
          
        }
      },
      timeDefaultShow: "",
      pickerDate: "",
      formselect: {},
      airoptions: [],
      deviceStatuList: {
        1: "正常",
        2: "报警",
        3: "利用",
      },
      GSNform: [],
      Linecolor: [
        "#28739A",
        "#51A470",
        "#FCBC5D",
        "#34A2BC",
        "#4A6AB5",
        "#6A6F89",
        "#CF554A",
        "#BECAD8",
        "#00A599",
        "#7AC3AB",
        "#689BA1",
        "#B9ECB0",
        "#9DA7E5",
      ],

      DataDeviceType: [],
      DataDeviceTypeWarning: [],

      DataIndustry: [],
      DataIndustryWarning: [],

      DataArea: [],
      DataAreaWarning: [],

      DataCenter: [],
      DataCenterWarning: [],
      StatisticsData: {
        tripCount: 0,
        totalCount: 0,
        currentCount: 0,
        rate: "",
      },
      UtilizationRate: "0%",
      DefaultUtilizationRate: "0%",
      monthList: [],
      monthData: null,
      Top10Data: [],
      Top10Month: [],
    };
  },
  async mounted() {
    let date = new Date();
    let year = date.getFullYear();
    let curMonth = date.getMonth();
    if(curMonth == 0){
      curMonth = 12;
      year=year-1;
    }
    var curDate =
      curMonth >= 10 ? year + "-" + curMonth : year + "-0" + curMonth;
    this.monthData = curDate;
    this.monthList = [curDate, curDate];

    if (this.$route.params.times) {
      this.monthList = this.$route.params.times;
      this.monthData = this.$route.params.times;
    }
    this.getStatisticsData();

    this.getDeviceRate_new();

    this.timeDefaultShow = new Date();
    this.timeDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  methods: {
    async changeMonth() {
      this.getStatisticsData();
      this.getDeviceRate_new();
    },
    async getIndustryUtilizationRate() {
      let taht = this;
      let postData = {
        language: this.activeLang,
        monthList: this.monthList,
      };
      let res = await getIndustryUtilizationRate(postData);
      this.Top10Data = res.result;
      let dateList = Array.from(
        new Set([].concat(...this.Top10Data.map((x) => x.dateList)))
      )
        .filter((x) => x != undefined)
        .sort();
      this.Top10Month = dateList;
      // if(dateList.length==0){
      //   let monthArr=this.monthData.split('-');
      //   for (let index = 0; index < 6; index++) {
      //     let number=Number.parseInt(monthArr[1]);
      //     this.Top10Month.push(monthArr[0]+(number<10?("0"+number):number))

      //   }
      // }
      console.log(this.Top10Month);
      this.Top10Data.forEach((element) => {
        dateList.forEach((elementDate, indexj) => {
          if (
            !element.dateList ||
            !element.dateList.some((x) => x == elementDate)
          ) {
            //如果没有该日期 就补零
            element.value.splice(indexj, 0, 0);
          }
        });
      });
      this.initLineDom("KchartLine", taht.Top10Data);
    },
    getStatisticsData() {
      let that = this;

      this.monthList = [this.monthData, this.monthData];
      let postData = {
        monthList: this.monthList,
      };
      getStatisticsData(postData).then((res) => {
        let data = res.result;
        that.StatisticsData.currentCount = res.result.currentCount;
      });
      // that.getIndustryRateSum();
    },
    getIndustryRateSum() {
      let that = this;

      this.monthList = [this.monthData, this.monthData];
      let postData = {
        monthList: this.monthList,
      };
      GetRateSumByMonthRange(postData).then((res) => {
        let data = res.result;
        that.DefaultUtilizationRate = data.rate + "%";
      });
    },
    async getDefaultIndustryRateSum() {
      let that = this;
      await GetIndustryRateSum().then((res) => {
        if (res.success && res.result) {
          that.DefaultUtilizationRate = res.result.rate + "%";
        }
      });
    },
    async getDeviceRate_new() {
      let that =this;
      that.monthList = [this.monthData, this.monthData];
      let postData = {
        language: that.activeLang,
        monthList: that.monthList,
      };
      let res = await getUtilizationRate_new(postData);
      let data = res.result;
      await that.getIndustryUtilizationRate();

      if (!data){
        that.DataDeviceTypeWarning=new Array();
        that.DataIndustryWarning=new Array();
        that.DataAreaWarning=new Array();
        that.DataCenterWarning=new Array();
      }else{
        that.DefaultUtilizationRate = res.result.utilizationRate + "%";


        that.DataDeviceTypeWarning = JSON.parse(data.deviceModelRank);
        if (that.activeLang!="zh"){
          that.DataDeviceTypeWarning.forEach(item=>{
            item.name = item.nameEng
          })
        }

        that.DataIndustryWarning = JSON.parse(data.industryRank);
        if (that.activeLang!="zh"){
          that.DataIndustryWarning.forEach(item=>{
            item.name = item.nameEng
          })
        }

        that.DataAreaWarning = JSON.parse(data.areaRank);
        if (that.activeLang!="zh"){
          that.DataAreaWarning.forEach(item=>{
            item.name = item.nameEng
          })
        }

        that.DataCenterWarning = JSON.parse(data.customerCenterRank);
        if (that.activeLang!="zh"){
          that.DataCenterWarning.forEach(item=>{
            item.name = item.nameEng
          })
        }
      }
      that.initBarDom("Kchart1b", that.DataDeviceTypeWarning);
      that.initBarDom("Kchart2b", that.DataIndustryWarning);
      that.initBarDom("Kchart3b", that.DataAreaWarning);
      that.initBarDom("Kchart4b", that.DataCenterWarning);
      // that.StatisticsData.currentCount = res.result.totalCount;

    },
    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    onSubmit() {},

    initPieDom(dom, data) {
      var Kchart = this.$echarts.init(document.getElementById(dom));
      Kchart.setOption(this.initPie(data, this.$t("title.industryRatio")));
      window.addEventListener("resize", () => {
        Kchart.resize();
      });
    },
    initBarDom(dom, data) {
      var Kchart = this.$echarts.init(document.getElementById(dom));
      Kchart.setOption(this.initBar(data));
      window.addEventListener("resize", () => {
        Kchart.resize();
      });
    },
    initLineDom(dom, data) {
      var Kchart = this.$echarts.init(document.getElementById(dom));
      Kchart.setOption(this.initLine(data), true);
      window.addEventListener("resize", () => {
        Kchart.resize();
      });
    },
    initPie(Data, name) {
      var mWidth = 0;
      if (this.isCollapse) {
        mWidth = document.documentElement.clientWidth - 226;
      } else {
        mWidth = document.documentElement.clientWidth - 97;
      }
      mWidth = (mWidth - 150) / 4 - 65;

      var temp = {
        toolbox: {
          right: 30,
          top: 24,
          feature: {
            saveAsImage: {
              type: "png",
              title: "Save as Image",
              icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABpUlEQVQ4T92UIWwUQRSG/3+4NhU4BKKCeiSuioaEpAJHapqQq4PcbZsAitvZnd3ZQwFJu3cBx4WkhuAqmjRpisIh8SAQCByClGN+ciVt7mCPZqGKZ2fe9+a9/39DnHHwjHmYCiyKJ/PS7C1As5NFeUgevojjux+rHjMVmBflKwRdIfl+PFHSAgzfJnF0sxbQ+/IAwGtro2w80fsyBXDV2mjpPwA61z9vGt/XKc5IapIcVLV8fCbpWwjntpxrfTluf0KUong6HzR8B2AO5BsR3bTT3h+fVdbtXaPQgbQI4Kth43Ic3zlR/DeVs2xzicbs0piO7bQeVw3ed/v3FEJXISyn6cZIvJOotE2e91ZAbRuaZhy3tscTiqK/GhQGEFeTpP3y14JTfeh9GQl4ROiGtet7o0Tvt64L3CFw39qorGWb0eXMlw8JttEwPz03DAeCeqmNHkxb2VN3OS96zyEtHwHI3SRur/1p/08FOucaxlw4mlUIn1ecc8N/Atb9jSZe6H05AHCpJuSDtVGz0th5Xt4mcbEOUMKnJImeVQLrgP5a5bpFfgAK760Vi6b0CgAAAABJRU5ErkJggg==",
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                  textFill: "#fff",
                },
              },
              backgroundColor: "#242731"
            },
          },
        },
        legend: {
          type: "scroll",
          icon: "circle",
          orient: "vertical",
          left: "45%",
          top: 90,
          bottom: 30,
          right: 30,
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 10,
          formatter: (name) => {
            return (
              // {name|' + item.name + '}
              "{name|" +
              name +
              "} {percent|" +
              Data.find((item) => {
                return item.name == name;
              }).value +
              "%" +
              "}"
            );
          },
          textStyle: {
            color: "#beceff", //元字颜色
            fontSize: 14,
            rich: {
              name: {
                color: "#fff",
                fontSize: 12,
                fontFamily: "Arial, 'microsoft yahei'",
                width: mWidth,
                align: "left",
              },
              percent: {
                color: "#fff",
                fontSize: 12,
                fontFamily: "Arial, 'microsoft yahei'",
                width: 60,
                align: "right",
              },
            },
          },
        },
        series: [
          // {
          //   name: name,
          //   type: "pie",
          //   radius: ["0%", "55%"],
          //   center: ["24%", "60%"],
          //   color: "#393C46",
          //   itemStyle: {
          //     normal: {
          //       label: {
          //         show: false,
          //       },
          //       labelLine: {
          //         show: false,
          //       },
          //     },
          //   },
          //   hoverAnimation: false,
          //   data: [
          //     {
          //       value: 1,
          //     },
          //   ],
          //   z: 1,
          // },
          {
            name: "",
            type: "pie",
            radius: ["0%", "55%"],
            center: ["24%", "60%"],
            color: this.Linecolor,
            data: Data.sort(function (a, b) {
              return a.value - b.value;
            }),
            labelLine: {
              show: false,
              length: 20,
              length2: 30,
            },

            label: {
              show: false,
              color: "#fff",
              lineHeight: 7,
              fontFamily: "Arial",
              formatter: function (params) {
                var percent = 0;
                var total = 0;
                for (var i = 0; i < Data.length; i++) {
                  total += Data[i].value;
                }
                percent = ((params.value / total) * 100).toFixed(0);
                if (params.name !== "") {
                  return params.name + ": " + percent + "%";
                } else {
                  return "";
                }
              },
            },
            z: 2,
          },
        ],
      };
      return temp;
    },
    initBar(Data) {
      var colorL = this.Linecolor;
      var temp = {
        toolbox: {
          right: 30,
          top: 24,
          feature: {
            saveAsImage: {
              type: "png",
              title: "Save as Image",
              icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABpUlEQVQ4T92UIWwUQRSG/3+4NhU4BKKCeiSuioaEpAJHapqQq4PcbZsAitvZnd3ZQwFJu3cBx4WkhuAqmjRpisIh8SAQCByClGN+ciVt7mCPZqGKZ2fe9+a9/39DnHHwjHmYCiyKJ/PS7C1As5NFeUgevojjux+rHjMVmBflKwRdIfl+PFHSAgzfJnF0sxbQ+/IAwGtro2w80fsyBXDV2mjpPwA61z9vGt/XKc5IapIcVLV8fCbpWwjntpxrfTluf0KUong6HzR8B2AO5BsR3bTT3h+fVdbtXaPQgbQI4Kth43Ic3zlR/DeVs2xzicbs0piO7bQeVw3ed/v3FEJXISyn6cZIvJOotE2e91ZAbRuaZhy3tscTiqK/GhQGEFeTpP3y14JTfeh9GQl4ROiGtet7o0Tvt64L3CFw39qorGWb0eXMlw8JttEwPz03DAeCeqmNHkxb2VN3OS96zyEtHwHI3SRur/1p/08FOucaxlw4mlUIn1ecc8N/Atb9jSZe6H05AHCpJuSDtVGz0th5Xt4mcbEOUMKnJImeVQLrgP5a5bpFfgAK760Vi6b0CgAAAABJRU5ErkJggg==",
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                  textFill: "#fff",
                },
              },
              backgroundColor: "#242731"
            },
          },
        },
        grid: {
          top: 100,
          left: 40,
          right: 30,
          bottom: 0,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: Data.map((item) => item.name),
            interval: 0,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 10,
                fontFamily: "Arial",
                lineHeight: 12,
              },
              interval: 0,
              formatter: function (params) {
                var newParamsName = ""; // 最终拼接成的字符串
                var paramsNameNumber = params.length; // 实际标签的个数
                var provideNumber = 6; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr; // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName;
              },
            },
            axisLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 5,
            axisLabel: {
              textStyle: {
                color: "#828393",
                fontSize: 10,
                fontFamily: "Arial",
              },
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            max: 100,
            min: 0,
          },
        ],

        series: [
          {
            name: "故障率",
            type: "bar",
            barWidth: "35%",
            data: Data.map((item) => item.value),
            label: {
              show: true,
              position: "top",
              formatter: "{c}%",
              fontFamily: "Arial",
              textStyle: {
                color: "#fff",
              },
            },
            itemStyle: {
              normal: {
                barBorderRadius: [5, 5, 0, 0],
                color: "#28739A",
              },
            },
          },
        ],
      };
      return temp;
    },

    initLine(Data) {
      var mWidth = 0;
      if (this.isCollapse) {
        mWidth = document.documentElement.clientWidth - 226;
      } else {
        mWidth = document.documentElement.clientWidth - 97;
      }
      mWidth = mWidth * 0.3 - 30;

      var colorL = this.Linecolor;
      var timeList = this.Top10Month;

      var series = [];
      var selected = [];

      for (let i = 0; i < Data.length; i++) {
        var seriesTemp = {
          name: Data[i].name,
          type: "line",
          smooth: true, //是否平滑
          showSymbol: false,
          symbolSize: 2,
          label: {
            show: false,
          },
          lineStyle: {
            normal: {
              color: colorL[i],
            },
          },
          itemStyle: {
            color: colorL[i],
            borderColor: colorL[i],
            borderWidth: 2,
          },
          emphasis: {
            focus: "series",
          },
          data: Data[i].value,
        };
        // var tempSe={
        //   Data[i].name
        // }
        series.push(seriesTemp);
      }

      var temp = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: "top",
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 12,
            fontFamily: "Arial",
          },
          formatter: function (params) {
            var temp = params[0].name;
            for (let i = 0; i < params.length; i++) {
              temp =
                temp +
                "<br />" +
                params[i].marker +
                params[i].seriesName +
                ": <span style='color:#fff;font-size:10px;font-family:Arial'>" +
                params[i].value +
                "%</span>";
            }
            return temp;
          },
        },
        toolbox: {
          right: 30,
          top: 24,
          feature: {
            saveAsImage: {
              type: "png",
              title: "Save as Image",
              icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABpUlEQVQ4T92UIWwUQRSG/3+4NhU4BKKCeiSuioaEpAJHapqQq4PcbZsAitvZnd3ZQwFJu3cBx4WkhuAqmjRpisIh8SAQCByClGN+ciVt7mCPZqGKZ2fe9+a9/39DnHHwjHmYCiyKJ/PS7C1As5NFeUgevojjux+rHjMVmBflKwRdIfl+PFHSAgzfJnF0sxbQ+/IAwGtro2w80fsyBXDV2mjpPwA61z9vGt/XKc5IapIcVLV8fCbpWwjntpxrfTluf0KUong6HzR8B2AO5BsR3bTT3h+fVdbtXaPQgbQI4Kth43Ic3zlR/DeVs2xzicbs0piO7bQeVw3ed/v3FEJXISyn6cZIvJOotE2e91ZAbRuaZhy3tscTiqK/GhQGEFeTpP3y14JTfeh9GQl4ROiGtet7o0Tvt64L3CFw39qorGWb0eXMlw8JttEwPz03DAeCeqmNHkxb2VN3OS96zyEtHwHI3SRur/1p/08FOucaxlw4mlUIn1ecc8N/Atb9jSZe6H05AHCpJuSDtVGz0th5Xt4mcbEOUMKnJImeVQLrgP5a5bpFfgAK760Vi6b0CgAAAABJRU5ErkJggg==",
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                  textFill: "#fff",
                },
              },
              backgroundColor: "#242731"
            },
          },
        },
        legend: {
          type: "scroll",
          icon: "circle",
          orient: "vertical",
          top: 80,
          right: 10,
          left: "68%",
          bottom: 10,
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 10,
          textStyle: {
            color: "#beceff", //元字颜色
          },
          pageIconSize: 10,
          pageTextStyle: {
            color: "#828393",
          },
          // width:"30%",
          // overflow:"break",
          // ellipsis: "...",
          formatter: (name) => {
            return (
              // {name|' + item.name + '}
              "{name|" +
              this.$echarts.format.truncateText(name, mWidth, "…") +
              "} "
            );
          },
          tooltip: {
            show: true,
          },
           textStyle: {
            color: "#beceff", //元字颜色
            fontSize: 14,
            rich: {
              name: {
                color: "#fff",
                fontSize: 12,
                fontFamily: "Arial, 'microsoft yahei'",
                width: mWidth,
                align: "left",
              },
              
            },
          },
        },
        grid: {
          top: 100,
          left: 40,
          right: "35%",
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: timeList,
          interval: 0,
          axisLabel: {
            textStyle: {
              margin: 5,
              color: "#828393",
              fontSize: 10,
              fontFamily: "Arial",
              lineHeight: 12,
            },
            interval: 0,
            formatter: function (params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var paramsNameNumber = params.length; // 实际标签的个数
              var provideNumber = 8; // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = ""; // 表示每一次截取的字符串
                  var start = p * provideNumber; // 开始截取的位置
                  var end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName;
            },
          },
          axisLine: {
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          boundaryGap: false,
        },
        yAxis: [
          {
            type: "value",
            splitNumber: 6,
            axisLabel: {
              textStyle: {
                color: "#828393",
                fontSize: 10,
                fontFamily: "Arial",
              },
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            min: 30,
            // min: function (value) {
            //   var temp = (value.min / 10 - 1).toFixed(0);
            //   return temp > 0 ? temp : 0;
            // },
            max: 100,
          },
        ],
        series: series,
      };
      return temp;
    },
    initEcharts() {
      // var Kchart1a = this.$echarts.init(document.getElementById("Kchart1a"));
      // Kchart1a.setOption(
      //   this.initPie(this.DataDeviceType, this.$t("title.modelRatio"))
      // );
      var Kchart1b = this.$echarts.init(document.getElementById("Kchart1b"));
      Kchart1b.setOption(this.initBar(this.DataDeviceTypeWarning));

      // var Kchart2a = this.$echarts.init(document.getElementById("Kchart2a"));
      // Kchart2a.setOption(
      //   this.initPie(this.DataIndustry, this.$t("title.industryRatio"))
      // );
      var Kchart2b = this.$echarts.init(document.getElementById("Kchart2b"));
      Kchart2b.setOption(this.initBar(this.DataIndustryWarning));

      // var Kchart3a = this.$echarts.init(document.getElementById("Kchart3a"));
      // Kchart3a.setOption(
      //   this.initPie(this.DataArea, this.$t("title.regionRatio"))
      // );
      var Kchart3b = this.$echarts.init(document.getElementById("Kchart3b"));
      Kchart3b.setOption(this.initBar(this.DataAreaWarning));

      // var Kchart4a = this.$echarts.init(document.getElementById("Kchart4a"));
      // Kchart4a.setOption(
      //   this.initPie(this.DataCenter, this.$t("title.customCenterRatio"))
      // );
      var Kchart4b = this.$echarts.init(document.getElementById("Kchart4b"));
      Kchart4b.setOption(this.initBar(this.DataCenterWarning));

      var KchartLine = this.$echarts.init(
        document.getElementById("KchartLine")
      );
      KchartLine.setOption(this.initLine(this.Top10Data), true);

      window.addEventListener("resize", () => {
        //Kchart1a.resize();
        Kchart1b.resize();
        //Kchart2a.resize();
        Kchart2b.resize();
        //Kchart3a.resize();
        Kchart3b.resize();
        //Kchart4a.resize();
        Kchart4b.resize();

        KchartLine.resize();
      });
    },

    handleCommand(command) {
      this.$router.push({
        name: command,
        params: {
          times: this.monthList,
        },
      });
    },
  },
  created() {
    this.$nextTick(() => {
      this.initEcharts();
    });
  },
};
</script>

 <style scope>
.el-form-item__content .el-input-group {
  vertical-align: middle;
}
.el-table__fixed-right {
  right: 10px !important;
}
</style>
